import { Injectable } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { PaymentForCardEndpoint } from '@app/services/paymentForCard/paymentForCard-endpoint.service';

@Injectable()
export class PaymentForCardService {
    constructor(private router: Router, private http: Http, private paymentforcardEndpoint: PaymentForCardEndpoint) {
    }
    paymentforcard() {
    return this.paymentforcardEndpoint.paymentforcard();
  }
} 


// WEBPACK FOOTER //
// ./src/app/services/paymentForCard/paymentForCard.service.ts